<template>
    <div id="app">
        <Main/>
    </div>
</template>

<script>
    import Main from './components/Main.vue'

    export default {
        name: 'app',
        components: {
            Main
        }
    }
</script>

<style>
    *, *:before, *:after {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    html, body {
        height: 100%;
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100%;
        overflow: hidden;
    }

    #sidebar .el-slider__input {
        width: 90px !important;
    }

    #sidebar .el-slider__runway.show-input {
        margin-right: 100px;
    }

    #sidebar .el-input-number--mini {
        width: 100px;
    }

    #sidebar .el-select {
        width: 100%;
    }
</style>
